module.exports = __webpack_public_path__ + "static/media/1.5cc2b6a4.jpg";